import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '902px'
  },
  previewInfo: {
    marginLeft: '145px',
    marginRight: '120px'
  },
  imageContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 284px)',
    justifyContent: 'space-between'
  },
  image: {
    width: '284px',
    height: '148px',
    float: 'left',
    marginBottom: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  }
}));
